const domain = 'https://adminht.okxweb3.top/';  //你的域名
export default {
  publicUrl:domain
}